import MicroFrontend from '../Microfrontend'

export function ProductWeightsOverview() {
    const productWeightsHost = process.env.REACT_APP_PRODUCT_WEIGHTS_OVERVIEW_HOST

    return (
            <MicroFrontend
                host={productWeightsHost}
                microFrontendUiName="ProductWeightsOverview"/>
    )
}